import classNames from "classnames";
import Login from "@components/Auth/Login";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import React from "react";
import Register from "@components/Auth/Register";
import toast from "react-hot-toast";
import { _WidgetProvider } from "@providers";
import { Accordion, Typography } from "@mui/material";
import {
  CustomerInfosArea,
  ReservationsArea,
  RewardArea,
} from "@components/Areas";
import { getAbsoluteImagePath } from "@utils/dom";
import { getCustomerUrlByWebUser, redirectTo } from "@utils/tools";
import { styled } from "@mui/material/styles";
import { Tab } from "@headlessui/react";
import { useAuth, useConfig, useLoadingScreen, useSession } from "@hooks";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { getLocalStorageItem } from "@utils/localStorage";
import { useSearchParams } from "react-router-dom";
import { LoginPartner } from "@components/Auth/Login/Login";

const languagesVarsCodes = [
  "LANG_neobooking_area_my_reservations_title", //Mes réservations
  "LANG_neobooking_area_my_informations_title", //Mon profil
  "LANG_neobooking_area_rewards_title", //Mes Récompenses
  "LANG_neobooking_logout", //Logout
  "LANG_neobooking_area_customer_title", //Mon espace client
  "LANG_neobooking_auth_to_log_in", //Se connecter
  "LANG_neobooking_auth_to_log_in_intro", //Connectez-vous pour accéder à votre espace client
  "LANG_neobooking_logout_in_progress", //Déconnexion en cours...
  "LANG_neobooking_logout_successfully", //Vous êtes maintenant déconnecté !
  "LANG_neobooking_please_wait", //Veuillez patienter quelques instants
  "LANG_neobooking_loading_customer_area_in_progress", //Chargement de l'espace client en cours...
];

type PageProps = {};

const AreaPage: React.FC<PageProps> = ({}) => {
  return (
    <div>
      <WidgetCustomerArea />
    </div>
  );
};

export const WidgetCustomerArea: React.FC<{}> = () => {
  /* Hooks */
  const { getLanguageVarValue, authMode } = useSession();
  const { user, loading, signout } = useAuth();
  const { mode: clientMode, logo } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";
  const [searchParams] = useSearchParams();

  const handleSignout = () => {
    const toastLogout = toast.loading(
      getLanguageVarValue("LANG_neobooking_logout_in_progress")
    );
    signout((err) => {
      if (!err) {
        toast.success(
          getLanguageVarValue("LANG_neobooking_logout_successfully"),
          {
            id: toastLogout,
          }
        );
        redirectTo(window.location.origin);
      } else
        toast.error(err.message, {
          id: toastLogout,
        });
    });
  };

  const customer_area = {
    [getLanguageVarValue("LANG_neobooking_area_my_reservations_title")]: {
      component: <ReservationsArea />,
    },
    [getLanguageVarValue("LANG_neobooking_area_my_informations_title")]: {
      component: <CustomerInfosArea />,
    },
    [getLanguageVarValue("LANG_neobooking_area_rewards_title")]: {
      component: <RewardArea />,
    },
  };

  const getCustomerAreas = () => {
    let obj = {
      [getLanguageVarValue("LANG_neobooking_area_my_reservations_title")]: {
        component: <ReservationsArea />,
      },
      [getLanguageVarValue("LANG_neobooking_area_my_informations_title")]: {
        component: <CustomerInfosArea />,
      },
    };

    if (authMode !== 2) {
      obj = {
        ...obj,
        [getLanguageVarValue("LANG_neobooking_area_rewards_title")]: {
          component: <RewardArea />,
        },
      };
    }

    return obj;
  };

  const getWebUser = () => {
    const localWebuser = getLocalStorageItem("webuser");
    return (
      searchParams.get("webuser") ??
      searchParams.get("wu") ??
      localWebuser ??
      process.env.REACT_APP_WEBUSER!!
    );
  };

  useLoadingScreen(
    loading,
    getLanguageVarValue("LANG_neobooking_loading_customer_area_in_progress"),
    getLanguageVarValue("LANG_neobooking_please_wait")
  );

  return (
    <div className="tw-container tw-mx-auto">
      <div
        className={`${
          mode === "vacanceole"
            ? "tw-bg-v_blue-light"
            : "tw-bg_corseole-secondary"
        } tw-flex tw-justify-between tw-py-2 tw-px-2 tw-text-white tw-mb-1`}
      >
        <a href={getCustomerUrlByWebUser(getWebUser(), mode)}>
          <img
            className="tw-w-20 md:tw-w-36"
            src={getAbsoluteImagePath(
              `/assets/img/customer/${
                mode === "vacanceole" ? "Vacanceole-B-RVB.png" : logo
              }`
            )}
          ></img>
        </a>
        {user && (
          <button
            className="tw-flex tw-flex-col tw-justify-center tw-items-center hover:tw-underline tw-text-v_blue-dark tw-font-montserrat"
            onClick={handleSignout}
            type="button"
          >
            <img
              className="tw-h-5 tw-w-5"
              src={getAbsoluteImagePath("/assets/img/icons/deconnexion.svg")}
            ></img>

            {getLanguageVarValue("LANG_neobooking_me_signout")}
          </button>
        )}
      </div>
      {user && !loading ? (
        <div>
          <Tab.Group>
            <Tab.List className="tw-flex tw-py-1">
              {Object.keys(getCustomerAreas()).map((area, areaIndex) => {
                return (
                  <Tab
                    key={`tab_area_customer_${areaIndex}`}
                    className={({ selected }: { selected: boolean }) =>
                      classNames(
                        "tw-w-full tw-p-2 tw-text-sm tw-leading-5 tw-text-gray-300",
                        "focus:tw-outline-none tw-border-b-[3px]",
                        "tw-transition-colors tw-duration-200 tw-ease-in-out tw-uppercase tw-font-montserrat",
                        selected
                          ? "tw-font-bold !tw-text-black tw-border-b-black"
                          : ""
                      )
                    }
                  >
                    {area}
                  </Tab>
                );
              })}
            </Tab.List>
            <Tab.Panels className="tw-mt-2">
              {Object.values(customer_area).map((area, areaIndex) => {
                return (
                  <Tab.Panel
                    key={`tabpanel_area_customer_${areaIndex}`}
                    className={classNames(
                      "tw-rounded-xl tw-bg-white tw-p-3",
                      " focus:tw-outline-none"
                    )}
                  >
                    {area.component}
                  </Tab.Panel>
                );
              })}
            </Tab.Panels>
          </Tab.Group>
        </div>
      ) : (
        !user &&
        !loading && (
          <div>
            <h1 className="tw-mt-4 tw-text-2xl tw-font-medium tw-text-center tw-font-dosis tw-mb-6">
              {getLanguageVarValue("LANG_neobooking_authentication")}
            </h1>
            {authMode !== 2 ? <AccordionAuth /> : <AccordionPartner />}
          </div>
        )
      )}
    </div>
  );
};

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <img
        className="tw-w-5 tw-h-5"
        src={getAbsoluteImagePath(`/assets/img/icons/carret_down.svg`)}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "white",
  border: "none",
  boxShadow: "0 3px 10px 2px rgb(0 0 0 / 20%)",
  "&.Mui-expanded.MuiAccordionSummary-root": {
    boxShadow: "none",
  },
  flexDirection: "revert",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

type AccordionAuthProps = {};

const AccordionAuth: React.FC<AccordionAuthProps> = ({}) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();
  /* State */
  const [expanded, setExpanded] =
    React.useState<"panel_login" | "panel_register" | false>("panel_login");

  const handleChange =
    (panel: "panel_login" | "panel_register") =>
    (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <Accordion
        expanded={expanded === "panel_login"}
        onChange={handleChange("panel_login")}
      >
        <AccordionSummary
          aria-controls="panel_logind-content"
          id="panel_logind-header"
        >
          <Typography>
            <span className="tw-titre-principal-dosis">
              {getLanguageVarValue("LANG_neobooking_i_already_have_account")}
            </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Login />
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel_register"}
        onChange={handleChange("panel_register")}
      >
        <AccordionSummary
          aria-controls="panel_registerd-content"
          id="panel_registerd-header"
        >
          <Typography>
            <span className="tw-titre-principal-dosis">
              {getLanguageVarValue("LANG_neobooking_i_new_client")}
            </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Register />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const AccordionPartner: React.FC<AccordionAuthProps> = ({}) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      <Accordion expanded={true}>
        <AccordionSummary>
          <Typography>
            <span className="tw-titre-principal-dosis">
              {getLanguageVarValue("LANG_neobooking_login_partner")}
            </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <LoginPartner />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AreaPage;
